export default __webpack_public_path__ + "slices/main/assets/public/media/product/engage/engagement-inspirations@2x.45326e503a34c7467f9d33036500dab8.png";